import { InvitationTable } from 'src/features/userManagement/components';

const Invitations = () => {
    return <InvitationTable />;
};

export { Invitations };
